// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2HZa5","controls":"styles_controls__2Nxpv","charLimit":"styles_charLimit__2I03e","input":"styles_input__3wF2f","send":"styles_send__2XqBC"};